<div class="lp2">

  <!-- ══ HEADER ══════════════════════════════════════════════════════ -->
  <header class="lp2-hdr">
    <div class="lp2-hdr-side lp2-hdr-left">
      <img src="assets/odisha-logo.png" alt="Government of Odisha" class="lp2-hdr-logo" />
      <div class="lp2-hdr-text">
        <span class="lp2-hdr-title">Government of Odisha</span>
        <span class="lp2-hdr-sub">Office of Hon'ble Minister</span>
      </div>
    </div>
    <div class="lp2-hdr-side lp2-hdr-right">
      <i class="fa-solid fa-shield-halved lp2-hdr-shield"></i>
      <div class="lp2-hdr-text lp2-hdr-text-right">
        <span class="lp2-hdr-title">Secure Government System</span>
        <span class="lp2-hdr-sub">All activities are logged</span>
      </div>
    </div>
  </header>

  <!-- ══ MAIN ════════════════════════════════════════════════════════ -->
  <main class="lp2-main">

    <!-- ── HERO PANEL ─────────────────────────────────────────────── -->
    <section class="lp2-hero">
      <div class="lp2-hero-bg"></div>
      <div class="lp2-hero-scrim"></div>

      <div class="lp2-hero-body">
        <span class="lp2-minister-tag"><i class="fa-solid fa-user"></i> Hon'ble Minister</span>
        <h2 class="lp2-minister-name">Sri Suryabanshi Suraj</h2>
        <p class="lp2-minister-role">Dhamnagar Assembly Constituency</p>
        <div class="lp2-hero-rule"></div>
        <blockquote class="lp2-quote">
          <i class="fa-solid fa-quote-left"></i>
          Committed to transparent development, efficient execution and inclusive growth of Dhamnagar.
          <i class="fa-solid fa-quote-right"></i>
        </blockquote>
      </div>

      <div class="lp2-hero-stats">
        <div class="lp2-hstat">
          <div class="lp2-hstat-ico blue"><i class="fa-solid fa-chart-simple"></i></div>
          <div class="lp2-hstat-text">
            <span class="lp2-hstat-val">1134+</span>
            <span class="lp2-hstat-lbl">Total Projects</span>
          </div>
        </div>
        <span class="lp2-hstat-divider"></span>
        <div class="lp2-hstat">
          <div class="lp2-hstat-ico green"><i class="fa-solid fa-circle-check"></i></div>
          <div class="lp2-hstat-text">
            <span class="lp2-hstat-val">50+</span>
            <span class="lp2-hstat-lbl">Departments</span>
          </div>
        </div>
        <span class="lp2-hstat-divider"></span>
        <div class="lp2-hstat">
          <div class="lp2-hstat-ico orange"><i class="fa-solid fa-users"></i></div>
          <div class="lp2-hstat-text">
            <span class="lp2-hstat-val">1000+</span>
            <span class="lp2-hstat-lbl">Field Users</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ── CARD PANEL ─────────────────────────────────────────────── -->
    <section class="lp2-card-panel">
      <div class="lp2-card">

        <div class="lp2-card-lock"><i class="fa-solid fa-lock"></i></div>
        <h1 class="lp2-card-title">Dhamnagar Development Dashboard (D3)</h1>
        <p class="lp2-card-sub">Project Monitoring &amp; Management System</p>
        <div class="lp2-card-rule"><span></span><i></i><span></span></div>

        <div class="lp2-access">
          <div class="lp2-access-ico"><i class="fa-solid fa-lock"></i></div>
          <div>
            <strong>Secure Access Portal</strong>
            <p>Please sign in to continue</p>
          </div>
        </div>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

          <div class="lp2-field">
            <label>Email Address</label>
            <div class="lp2-input-wrap">
              <i class="fa-regular fa-user lp2-fld-ico"></i>
              <input type="email" formControlName="email" placeholder="minister@nimbletech.co.in" />
            </div>
            @if (isFieldInvalid('email')) {
              <div class="lp2-fld-err">{{ getFieldError('email') }}</div>
            }
          </div>

          <div class="lp2-field">
            <label>Password</label>
            <div class="lp2-input-wrap">
              <i class="fa-solid fa-lock lp2-fld-ico"></i>
              <input [type]="showPassword() ? 'text' : 'password'"
                     formControlName="password" placeholder="••••••••••••" />
              <button type="button" class="lp2-eye" (click)="togglePasswordVisibility()">
                <i class="fa-regular"
                   [class.fa-eye]="!showPassword()"
                   [class.fa-eye-slash]="showPassword()"></i>
              </button>
            </div>
            @if (isFieldInvalid('password')) {
              <div class="lp2-fld-err">{{ getFieldError('password') }}</div>
            }
          </div>

          <div class="lp2-form-row">
            <label class="lp2-chk">
              <input type="checkbox" formControlName="rememberMe" />
              <span>Remember me</span>
            </label>
            <a href="javascript:void(0)" class="lp2-forgot" (click)="forgotPassword()">Forgot Password?</a>
          </div>

          @if (errorMessage()) {
            <div class="lp2-msg lp2-msg-err">{{ errorMessage() }}</div>
          }
          @if (successMessage()) {
            <div class="lp2-msg lp2-msg-ok">{{ successMessage() }}</div>
          }

          <button type="submit" class="lp2-btn-signin" [disabled]="isLoading()">
            @if (isLoading()) {
              <i class="fa-solid fa-spinner fa-spin"></i> Signing in&hellip;
            } @else {
              <i class="fa-solid fa-lock"></i> SIGN IN
            }
          </button>

        </form>

        <div class="lp2-divider"><span></span><em>OR</em><span></span></div>

        <button type="button" class="lp2-govid-btn">
          <i class="fa-regular fa-id-card"></i> Sign in with Government ID
        </button>

        <div class="lp2-restricted">
          <div class="lp2-restricted-ico"><i class="fa-solid fa-shield-halved"></i></div>
          <div>
            <strong>Restricted Access</strong>
            <p>Unauthorized access is prohibited. System usage is logged for audit purposes.</p>
          </div>
        </div>

        <div class="lp2-notice">
          <div class="lp2-notice-ico"><i class="fa-regular fa-bell"></i></div>
          <div>
            <strong>System Notice</strong>
            <p>This is a confidential government system. By logging in, you agree to comply with all security and usage policies.</p>
          </div>
        </div>

      </div>
    </section>

  </main>

  <!-- ══ FEATURE STRIP ══════════════════════════════════════════════ -->
  <section class="lp2-feats">
    <div class="lp2-feat">
      <div class="lp2-feat-ico blue"><i class="fa-solid fa-shield-halved"></i></div>
      <div>
        <strong>Secure Login</strong>
        <span>256-bit SSL encryption for maximum security</span>
      </div>
    </div>
    <div class="lp2-feat">
      <div class="lp2-feat-ico green"><i class="fa-solid fa-user-check"></i></div>
      <div>
        <strong>Role Based Access</strong>
        <span>Access granted based on user role &amp; permissions</span>
      </div>
    </div>
    <div class="lp2-feat">
      <div class="lp2-feat-ico orange"><i class="fa-solid fa-file-invoice"></i></div>
      <div>
        <strong>Activity Monitoring</strong>
        <span>All actions are monitored and recorded</span>
      </div>
    </div>
    <div class="lp2-feat">
      <div class="lp2-feat-ico purple"><i class="fa-solid fa-lock"></i></div>
      <div>
        <strong>Data Protection</strong>
        <span>Your data is safe and confidential</span>
      </div>
    </div>
  </section>

  <!-- ══ FOOTER ═════════════════════════════════════════════════════ -->
  <footer class="lp2-footer">
    <span class="lp2-footer-copy">&copy; 2024 Government of Odisha. All Rights Reserved.</span>
    <div class="lp2-footer-brand">
      <img src="assets/odisha-logo.png" alt="Odisha" />
      <div>
        <strong>Odisha</strong>
        <span>Driven by Development</span>
      </div>
    </div>
    <span class="lp2-footer-meta">
      Version 1.0.0 &nbsp;|&nbsp; <i class="fa-regular fa-calendar"></i> Last Login: {{ lastLoginDate() }}
    </span>
  </footer>

</div>
